import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteNotification: (
  fetchContext: FetchContext,
  notificationId: number,
  accessToken?: string) => Promise<void> = (fetchContext, notificationId, accessToken) => 
    fetch(`${fetchContext.baseUrl}/api/staff/notifications/${notificationId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete notification'));
